var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import ConenidoVentana from './contenido-ventana';
import { MarcoAmpliacion, Precarga } from '../index';
import { Pizarra } from '../index';
var ContenidoTipoPng = (_temp = _class = function (_Component) {
  _inherits(ContenidoTipoPng, _Component); // TODO: Escalar todos los hijos al tamaño de la imagen que pintamos
  // para que tanto pizarra como textosUsuario permanezcan en posiciones
  // relativas coherentes respecto a la imagen que se pinta


  function ContenidoTipoPng(props) {
    _classCallCheck(this, ContenidoTipoPng);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.calcularImagenRect = function () {
      var imagenRect = _this.imagenRef.current.getBoundingClientRect();

      var _this$state$imagenRec = _this.state.imagenRect,
          width = _this$state$imagenRec.width,
          height = _this$state$imagenRec.height;

      if (width !== imagenRect.width || height !== imagenRect.height) {
        _this.setState({
          imagenRect: imagenRect
        });
      }
    };

    _this.handleImagenLoaded = function () {
      var _this$imagenRef$curre = _this.imagenRef.current,
          naturalWidth = _this$imagenRef$curre.naturalWidth,
          naturalHeight = _this$imagenRef$curre.naturalHeight;

      _this.setState({
        loading: false,
        imagenNaturalSize: {
          width: naturalWidth,
          height: naturalHeight
        }
      }, _this.calcularImagenRect);
    };

    _this.state = {
      loading: true,
      // resized: props.resized,
      hasVerticalScrollbar: false,
      imagenRect: {
        width: "100%",
        height: "100%"
      },
      imagenNaturalSize: null
    };
    _this.imagenRef = React.createRef();
    _this.marcoAmpliacionRef = React.createRef();
    return _this;
  }

  ContenidoTipoPng.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    if (prevProps.imagen !== this.props.imagen) {
      this.setState({
        loading: true
      });
      return;
    }

    if (prevProps.factor !== this.props.factor) {
      window.setTimeout(function () {
        var forzarTopCero = _this2.hayScrollY();

        _this2.setState({
          forzarTopCero: forzarTopCero
        });
      }, 33);
      window.setTimeout(function () {
        var forzarLeftCero = _this2.hayScrollX();

        _this2.setState({
          forzarLeftCero: forzarLeftCero
        });
      }, 33);
    }

    window.setTimeout(function () {
      return _this2.calcularImagenRect();
    }, 10);
  };

  ContenidoTipoPng.prototype.hayScrollY = function hayScrollY() {
    var marcoAmpliacion = this.marcoAmpliacionRef.current;

    if (!marcoAmpliacion) {
      return false;
    }

    var resultado = marcoAmpliacion.elem.clientHeight < marcoAmpliacion.elem.scrollHeight;
    return resultado;
  };

  ContenidoTipoPng.prototype.hayScrollX = function hayScrollX() {
    var marcoAmpliacion = this.marcoAmpliacionRef.current;

    if (!marcoAmpliacion) {
      return false;
    }

    var resultado = marcoAmpliacion.elem.clientWidth < marcoAmpliacion.elem.scrollWidth;
    return resultado;
  };

  ContenidoTipoPng.prototype.render = function render() {
    var _props = this.props,
        imagen = _props.imagen,
        factor = _props.factor,
        ajuste = _props.ajuste,
        escala = _props.escala,
        lupa = _props.lupa,
        imagenUsuarioVisible = _props.imagenUsuarioVisible;
    var _state = this.state,
        loading = _state.loading,
        imagenNaturalSize = _state.imagenNaturalSize,
        imagenRect = _state.imagenRect,
        forzarTopCero = _state.forzarTopCero,
        forzarLeftCero = _state.forzarLeftCero;
    var factorReal = factor * escala / 100;
    var transformX = factorReal > 100 ? -50 + (factorReal - 100) / (2 * factorReal / 100) : -50;
    var valorLeft = forzarLeftCero ? 0 : 1;
    var imagenStyle = lupa === "si" ? // lupa = si
    ajuste === "ancho" || forzarTopCero ? {
      position: "absolute",
      width: factor * escala / 100 + '%',
      top: 0,
      left: valorLeft * 50 + '%',
      transform: 'translate(' + valorLeft * -50 + '%, 0%)',
      maxWidth: imagenNaturalSize ? factor * imagenNaturalSize.width / 100 : factor + '%'
    } : {
      position: "absolute",
      width: factor * escala / 100 + '%',
      top: "50%",
      left: valorLeft * 50 + '%',
      transform: 'translate(' + valorLeft * transformX + '%, -50%)',
      maxWidth: imagenNaturalSize ? factor * imagenNaturalSize.width / 100 : factor + '%'
    } : // lupa = no
    ajuste === "ancho" ? {
      position: "absolute",
      width: escala + '%',
      top: 0,
      left: "50%",
      transform: "translate(-50%, 0)",
      maxWidth: imagenNaturalSize ? imagenNaturalSize.width : '100%'
    } : {
      position: "absolute",
      maxWidth: escala + '%',
      maxHeight: escala + '%',
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    };
    imagenStyle.display = loading ? 'none' : 'block';
    return React.createElement(ConenidoVentana, null, React.createElement(MarcoAmpliacion, {
      id: 'contenido-tipo-png',
      factor: 100,
      deshabilitado: true,
      onDragged: function onDragged() {},
      ref: this.marcoAmpliacionRef
    }, React.createElement('img', {
      ref: this.imagenRef,
      onLoad: this.handleImagenLoaded,
      src: imagen,
      style: imagenStyle,
      alt: ''
    }), loading && React.createElement(Precarga, null), !loading && React.createElement('div', {
      className: 'contenido-tipo-png-children',
      style: _extends({}, imagenStyle, {
        width: imagenRect.width,
        height: imagenRect.height
      })
    }, React.createElement(Pizarra, {
      visible: imagenUsuarioVisible,
      resolucion: {
        w: imagenNaturalSize.width,
        h: imagenNaturalSize.height
      }
    }), this.props.children)));
  };

  return ContenidoTipoPng;
}(Component), _class.defaultProps = {
  ajuste: "auto",
  escala: 100
}, _temp);
ContenidoTipoPng.propTypes = process.env.NODE_ENV !== "production" ? {
  // marcoAmpliacionId: t.string,
  factor: t.number,
  imagen: t.string,

  /** ajuste del recorte */
  ajuste: t.oneOf(['auto', 'ancho', 'escala', 'alto']),

  /** escala del contenedor */
  escala: t.number,
  lupa: t.string,

  /** nos informa de que el contenedor padre ha cambiado de tamaño */
  onResize: t.func,

  /** espacio disponible */
  anchoDisponible: t.number,
  altoDisponible: t.number,
  imagenUsuarioVisible: t.bool,
  children: t.any
} : {};
export default ContenidoTipoPng;